/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-09-18 16:01:36
 * @LastEditors: huangfuchunmei
 * @message: 权益查询-banner组件
 */
import React from "react";
import { useDevice } from "@/hooks";
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia"
import { IBanner } from "@/common/types";

interface IProps {
  banner: IBanner; // banner
  ctry: string;
  words: Record<string, string>;
}


const Banner = (props:IProps) => {
  const {ctry, words, banner} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  return (
    <>
      {banner && (
        <div className={styles["banner-wrap"]}>
          {banner[newDevice].extension === '.mp4'
            ? <LazyMedia type="video" LazyClassName="full-wh" className={styles['banner-img']} loop autoPlay preload="auto" playsInline muted src={banner[newDevice]?.url}></LazyMedia>
            : <LazyMedia type="image" LazyClassName="full-wh" className={styles['banner-img']} src={banner[newDevice]?.url} alt={banner[newDevice]?.alt} />
          }
          <div className={styles["banner-content"]}>
            {banner?.isShowTitle === 1 && (
              <h1 className={styles["banner-title"]}>{banner?.name}</h1>
            )}
            <p>{banner?.briefIntroduction}</p>
          </div>
        </div>
      )}
    </>
  )
}
export default Banner